<template>
  <div class="star-rating-with-labels">
    <div class="stars-labels-row">
      <span
        v-for="(label, idx) in labels"
        :key="idx"
        @mouseenter="onHover(idx + 1)"
        @mouseleave="onHover(0)"
        class="star-label-pair"
        @click="onClick(idx + 1)"
        :style="{ cursor: interactive ? 'pointer' : 'default' }"
      >
        <svg
          :width="starSize"
          :height="starSize"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12 18.26l-5.76 3.04c-.68.36-1.48-.23-1.32-.99l1.1-6.36-4.66-4.54c-.54-.53-.24-1.44.5-1.55l6.45-.94 2.88-5.83c.33-.67 1.28-.67 1.61 0l2.88 5.83 6.45.94c.74.11 1.04 1.02.5 1.55l-4.66 4.54 1.1 6.36c.16.76-.64 1.35-1.32.99L12 18.26z"
            :fill="getStarColor(idx)"
          />
        </svg>
        <span class="star-label" :style="labelStyle">
          {{ label }}
        </span>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "StarRatingWithLabels",
  props: {
    value: {
      type: Number,
      default: 0,
    },
    labels: {
      type: Array,
      default: () => ["worst", "Bad", "Neutral", "Good", "Excellent"],
    },
    starSize: {
      type: [Number, String],
      default: 48,
    },
    activeColor: {
      type: String,
      default: "#FFC107", // Amber
    },
    inactiveColor: {
      type: String,
      default: "#E0E0E0", // Grey
    },
    interactive: {
      type: Boolean,
      default: false,
    },
    labelStyle: {
      type: Object,
      default: () => ({
        color: "#3d2586",
        fontWeight: "bold",
        fontSize: "1rem",
        textTransform: "capitalize",
      }),
    },
    disableHover: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      hoverValue: 0,
    };
  },
  methods: {
    getStarColor(idx) {
      const current = this.hoverValue || this.value;
      return idx < current ? this.activeColor : this.inactiveColor;
    },
    onHover(val) {
      if (this.interactive && !this.disableHover) {
        this.hoverValue = val;
      }
    },
    onClick(val) {
      if (this.interactive) {
        this.$emit("input", val);
        this.$emit("change", val);
      }
    },
  },
};
</script>

<style scoped>
.star-rating-with-labels {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}
.stars-labels-row {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  width: 100%;
  max-width: 400px;
}
.star-label-pair {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
  transition: transform 0.15s;
}
.star-label-pair:hover {
  transform: scale(1);
}
.star-label {
  margin-top: 8px;
  text-align: center;
}
</style>
